<template>
  <v-dialog v-model="value" persistent max-width="1100px">
    <material-card color="primary" :title="title">
      <v-form ref="form" v-model="validForm">
        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex xs12 sm612 md12>

            <v-tabs
              v-model="active"
              color="secondary"
              dark
              slider-color="red">

               <v-tab>
                 PART A: Naranjo’s algorithm
                </v-tab>

                 <v-tab>
                 PART B: Global Introspection 
                </v-tab>

                <!--v-tab>
                 PART C: Protocol instructed req.
                </v-tab-->

                <v-tab-item style="min-height:575px">

                    <v-data-table
                      :items="causality.naranjo_answers"
                      hide-actions
                      :headers="[
                        { text: 'Question', sortable: false },
                        { text: 'Yes', sortable: false },
                        { text: 'No', sortable: false },
                        { text: 'Do not know', sortable: false }]"
                    >

                    <template slot="items" slot-scope="{ item }" >
                      <td>
                        {{ item.name }}
                        </td>
                      <td>
                         <v-radio-group v-model="item.value">
                            <v-radio  value="yes"></v-radio>
                         </v-radio-group>
                      </td>
                      <td>
                         <v-radio-group v-model="item.value">
                            <v-radio  value="no"></v-radio>
                         </v-radio-group>
                      </td>
                      <td>
                         <v-radio-group v-model="item.value">
                            <v-radio  value="dontknow"></v-radio>
                         </v-radio-group>
                      </td>
                    </template>
                  </v-data-table>

                  <v-divider />

                  <div>
                    ADR is : {{adr}}
                  </div>

                </v-tab-item>

                <v-tab-item style="min-height:575px">
                   
                   <table id="table_part_b">
                     <tr>
                      <td colspan=3><b>{{ causality.part_b.name }}</b></td>
                    </tr>
                    <tr>
                      <td>
                        <v-radio-group v-model="causality.part_b.value">
                          <v-radio label="Certain" value="Certain"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-radio-group v-model="causality.part_b.value">
                          <v-radio label="Probable/Likely" value="Probable/Likely"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-radio-group v-model="causality.part_b.value">
                          <v-radio label="Possible" value="Possible"></v-radio>
                        </v-radio-group>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <v-radio-group v-model="causality.part_b.value">
                        <v-radio label="Unlikely" value="Unlikely"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-radio-group v-model="causality.part_b.value">
                          <v-radio label="Conditional/Unclassified" value="Conditional/Unclassified"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-radio-group v-model="causality.part_b.value">
                          <v-radio label="Un-assessable/Unclassifiable" value="Un-assessable/Unclassifiable"></v-radio>
                        </v-radio-group>
                      </td>
                    </tr>
                   </table>
                   
                  <table id="table_part_b_legend">
                    <tr>
                      <td colspan=2><b>Causality term Assessment criteria (All points should be reasonably complied with)</b></td>
                    </tr>

                    <tr>
                      <td>Certain</td>
                      <td>
                        <li>Event or laboratory test abnormality, with plausible time relationship to drug intake</li>
                        <li>Cannot be explained by disease or other drugs</li>
                        <li>Response to withdrawal plausible (pharmacologically, pathologically)</li>
                        <li>Event definitive pharmacologically or phenomenologically (i.e. an objective and specific medical disorder or a recognized pharmacological phenomenon) </li>
                        <li>Re-challenge satisfactory, if necessary</li>
                      </td>
                    </tr>

                     <tr>
                      <td>Probable/Likely</td>
                      <td>
                         <li>Event or laboratory test abnormality, with reasonable time relationship to drug intake</li>
                         <li>Unlikely to be attributed to disease or other drugs</li>
                         <li>Response to withdrawal clinically reasonable</li>
                         <li>Re-challenge not required</li>
                      </td>
                    </tr>

                     <tr>
                      <td>Possible</td>
                      <td>
                        <li> Event or laboratory test abnormality, with reasonable time relationship to drug intake </li>
                        <li> Could also be explained by disease or other drugs</li>
                        <li> Information on drug withdrawal may be lacking or unclear </li>
                      </td>
                    </tr>

                     <tr>
                      <td>Unlikely</td>
                      <td>
                        <li> Event or laboratory test abnormality, with a time to drug intake that makes a relationship improbable (but not impossible) </li>
                        <li> Disease or other drugs provide plausible explanations </li>
                      </td>
                    </tr>

                     <tr>
                      <td>Conditional/Unclassified</td>
                      <td>
                        <li> Event or laboratory test abnormality</li>
                        <li> More data for proper assessment needed, or </li>
                        <li> Additional data under examination </li>
                      </td>
                    </tr>

                     <tr>
                      <td>Unassessable/Unclassifiable</td>
                      <td>
                        <li> Report suggesting an adverse reaction</li>
                        <li> Cannot be judged because information is insufficient or contradictory </li>
                        <li> Data cannot be supplemented or verified </li>
                      </td>
                    </tr>

                  </table>

                </v-tab-item>

                <!--v-tab-item style="min-height:575px">
                    <v-data-table
                      :items="causality.part_c"
                      hide-actions
                      :headers="[
                        { text: 'Question', sortable: false },
                        { text: 'Yes', sortable: false },
                        { text: 'No', sortable: false },
                        { text: 'NA', sortable: false }]"
                    >
                    <template slot="items" slot-scope="{ item }" >
                      <td>{{ item.name }}</td>
                      <td>
                        <v-radio-group v-model="item.value">
                          <v-radio  value="yes"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-radio-group v-model="item.value">
                          <v-radio  value="no"></v-radio>
                        </v-radio-group>
                      </td>
                      <td>
                        <v-radio-group v-model="item.value">
                          <v-radio  value="na"></v-radio>
                        </v-radio-group>
                      </td>
                    </template>
                  </v-data-table>
                </v-tab-item-->

              </v-tabs>

            </v-flex>
       
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()" small
          >Close</v-btn
        >

        <v-btn class="mx-1 font-weight-light" color="pink" :disabled="!sae.causality" @click="downloadPdf()" small
          >Pdf</v-btn>

        <v-btn
          v-if="$can('upsert', 'adverse_event')"
          small
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!checkSave()"
          @click="save()"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail, searchCausalityByCin, causalityPdf } from "@/api/adverse_event";
import validators from "@/utils/validators";
import dayjs from "dayjs";

export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    sae: Object
  },
  data() {
    return {
      active: 0,
      causality: {
        naranjo_result: null,
        //ISSUE 645
        naranjo_answers_cpy: null,
        //ISSUE 645
        naranjo_answers: [
          { 
            name : 'Are there previous conclusive reports on this reaction?',
            value: null,
            calc: { yes:1, no:0, dontknow:0}
          },
          {
            name: 'Did the adverse event appear after the suspected drug was administered?',
            value: null,
            calc: { yes:2, no:-1, dontknow:0}
          },
          {
            name : 'Did the adverse reaction improve when the drug was discontinued, or a specific antagonist was administered?',
            value: null,
            calc: { yes:1, no:0, dontknow:0}
          },
          {
            name : 'Did the adverse reaction reappear when the drug was re-administered?',
            value: null,
            calc: { yes:2, no:-1, dontknow:0}
          },
          {
            name : 'Are there alternative causes (other than the drug) that could solely have caused the reaction?',
            value: null,
            calc: { yes:-1, no:2, dontknow:0}
          },
          {
            name : 'Was the drug detected in the blood (or other fluids) in a concentration known to be toxic?',
            value: null,
            calc: { yes:1, no:0, dontknow:0}
          },
          {
            name : 'Was the reaction more severe when the dose was increased, or less severe when the dose was decreased?',
            value: null,
            calc: { yes:1, no:0, dontknow:0}
          },
          {
            name : 'Did the patient have a similar reaction to the same or similar drugs in any previous exposure?',
            value: null,
            calc: { yes:1, no:0, dontknow:0}
          },
          {
            name : 'Was the adverse event confirmed by objective evidence?',
            value: null,
            calc: { yes:1, no:0, dontknow:0}
          }
        ],
        part_b:  {
            name: 'Adverse Event considered as:',
            value: null
        },
      },
      validForm: true,
      validators,
      loadedSae: {}
    };
  },
  mounted() {
    //ISSUE 645
    if (this.causality.naranjo_answers_cpy === null)
    {
      this.causality.naranjo_answers_cpy = JSON.parse(JSON.stringify( this.causality.naranjo_answers))
    }
    //ISSUE 645
  },
  watch: {
    value(v) {
      
      this.$refs.form.reset();
      // get db value
      if (v) {
        getDetail(this.sae.id).then( data => {
          this.loadedSae = data;
          if (this.loadedSae.causality) {
            this.causality = this.loadedSae.causality
            //ISSUE 645
            this.causality.naranjo_answers_cpy = JSON.parse(JSON.stringify( this.causality.naranjo_answers))
            //ISSUE 645
          } else {
            
              searchCausalityByCin(this.sae.id).then( ret => {
                  if (ret.status == 'exists') {
                    this.causality = ret.previous.causality
                  }
              })

          }
          
        });
      }

    },
  },
  computed: {
    title() {
      return "Causality for SAE " + this.sae.cin + ' - ' + this.sae.id
    },
    adr() {
      let count = 0;
      this.causality.naranjo_answers.map( el => {
        if(el.value) {
          count += el.calc[el.value]
        }
      })

       if (count>=9) {
          return "Certain";
        }

        if (count>=5 && count <=8) {
          return "Probable";
        }

        if (count>=1 && count <=4) {
          return "Possible";
        }

        if (count<=0) {
          return "Unlikely";
        }
        return count
    }
  },
  methods: {

    close() {
      this.$emit("input", false);
    },
    pdf() {

    },
    checkSave() {
      //ISSUE 645
      var ret  = (JSON.stringify(this.causality.naranjo_answers_cpy) !== JSON.stringify(this.causality.naranjo_answers))
      return  ret
      //ISSUE 645
    },
    save() {
      this.causality.naranjo_result = this.adr;
      this.causality.date = dayjs().format('YYYY-MM-DD')
      this.causality.user = this.$store.getters.user
      this.loadedSae.causality = this.causality;
      upsert(this.loadedSae)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Causality section updated correctly",
            color: "success"
          });
          this.$emit('update:sae', this.loadedSae)
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the SAE Causality section. " +
              e.response.data.message,
            color: "error"
          });
        });
    },
    downloadPdf() {
      causalityPdf(this.sae.id).then( data => {
        this.$store.dispatch("app/openSnackbar", {
          message: "Causality PDF downloaded correctly",
          color: "success"
        });
      }).catch( e => {
        this.$store.dispatch("app/openSnackbar", {
          message:
            "An Error occurred during the Causality PDF creation. " +
            e.response.data.message,
          color: "error"
        });
      })
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
#table_part_b td {
  padding:0px
}
#table_part_b_legend td {
  font-size:12px;
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
  border-left: 1px solid gray;
  padding:5px;
}

#table_part_b_legend {
  border-collapse: collapse;
  border: 1px solid gray;
  width:100%;
}

.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom:0px !important;
}
.v-input--radio-group .v-messages {
  min-height:0px;
}

</style>
